import {Component, OnInit} from '@angular/core';
import {SalesVerificationCodeComponent} from '../sales-verification-code.component';

@Component({
  selector: 'app-sales-verification-code-v3',
  templateUrl: './sales-verification-code-v3.component.html',
})
export class SalesVerificationCodeComponentV3 extends SalesVerificationCodeComponent implements OnInit {
  override ngOnInit() {
    this.initEmailForm();
    this.initCodeForm();
    this.showGetOtpOptions();
    this.utilService.disablePageLoading();
  }
}